import { Navigate, Route, Routes } from "react-router-dom";
import MainLayout from "./components/layout-components/MainLayout";
import { ACCRUAL_BALANCE_PAGE, ERROR_PAGE, LAST_PUNCH_PAGE, ONLINE_SCHEDULE_SELF_SERVICE, PUNCH_INFO_PAGE, REACT_ATTESTATION, REACT_EMPLOYEE_LOGIN_SCREEN, REACT_FEEDBACK_SCREEN, REACT_FUNCTION_KEY_SCREEN, REACT_GENERAL_QUESTION, REACT_LABOR_CODE, REACT_PUNCH_LOCKOUT, REACT_TERMINAL_PAGE, RESET_PASSWORD } from "./constants/ReactEndPoints";
import Dashboard from "./pages/dashboard/Dashboard";
import LabourCode from "./pages/dashboard/LabourCode";
import TerminalRegistration from "./pages/dashboard/TerminalRegistration";
import EmployeeLogin from './pages/employee/EmployeeLogin';
import Attestation from "./pages/dashboard/Attestation";
import FeedBackScreen from "./pages/dashboard/FeedBackScreen";
import GeneralQuestion from "./pages/dashboard/GeneralQuestion";
import AccrualBalance from "./pages/dashboard/AccrualBalance";
import PunchInfo from "./pages/dashboard/PunchInfo";
import LastPunch from "./pages/dashboard/Lastpunch";
import ResetPassword from "./pages/employee/ResetPassword";
import GlobalErrorPage from "./components/GlobalErrorPage";
import OnlineSchedule from "./pages/dashboard/OnlineSchedule";
import PunchLockoutPage from "./pages/dashboard/PunchLockoutPage";

export default function AppRoutes() {
  return (
    <Routes>
      <Route path={"/"} element={<Navigate to={(localStorage.getItem('terminal') !== null && localStorage.getItem('terminal') !== undefined) ? REACT_EMPLOYEE_LOGIN_SCREEN : REACT_TERMINAL_PAGE} />} />
      <Route path={"/webpunch"} element={<Navigate to={(localStorage.getItem('terminal') !== null && localStorage.getItem('terminal') !== undefined) ? REACT_EMPLOYEE_LOGIN_SCREEN : REACT_TERMINAL_PAGE} />} />
      <Route path={ERROR_PAGE} element={<GlobalErrorPage/>} />
      <Route path={REACT_TERMINAL_PAGE} element={
        <MainLayout>
          <TerminalRegistration />
        </MainLayout>
      } />
      <Route
        path={REACT_FUNCTION_KEY_SCREEN}
        element={
          <MainLayout>
            <Dashboard />
          </MainLayout>
        }
      />
      <Route path={REACT_EMPLOYEE_LOGIN_SCREEN} element={
        <MainLayout>
          <EmployeeLogin />
        </MainLayout>
      }
      />
      <Route path={REACT_LABOR_CODE} element={
        <MainLayout>
          <LabourCode />
        </MainLayout>
      }
      />
      <Route path={REACT_ATTESTATION} element={
        <MainLayout>
          <Attestation />
        </MainLayout>
      }
      />
       <Route path={REACT_FEEDBACK_SCREEN} element={
        <MainLayout>
          <FeedBackScreen />
        </MainLayout>
      }
      />

      <Route path={REACT_PUNCH_LOCKOUT} element={
        <MainLayout>
          <PunchLockoutPage />
        </MainLayout>
      }
      />
        <Route path={REACT_GENERAL_QUESTION} element={
        <MainLayout>
          <GeneralQuestion />
        </MainLayout>
      }
      />
        <Route path={ACCRUAL_BALANCE_PAGE} element={
        <MainLayout>
          <AccrualBalance />
        </MainLayout>
      }
      />

     <Route path={PUNCH_INFO_PAGE} element={
        <MainLayout>
          <PunchInfo />
        </MainLayout>
      }
      />

      <Route path={LAST_PUNCH_PAGE} element={
        <MainLayout>
          <LastPunch />
        </MainLayout>
      }
      />
     {/* Reset employee web punch login password */}
      <Route path={RESET_PASSWORD} element={
        <MainLayout>
          <ResetPassword />
        </MainLayout>
      }
      />


      {/* Self Service Online Shift Details */}
      <Route path={ONLINE_SCHEDULE_SELF_SERVICE} element={
        <MainLayout>
          <OnlineSchedule/>
        </MainLayout>
      }
      />
      
    </Routes>
  );
}
